// Components==============
import Layout from 'components/Layout';
import Container from 'components/UI/Container';
import HeroLayout from 'components/UI/HeroLayout';
import AmbassadorIndex from 'actions/ambassador/index';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './Ambassadors.module.scss';
import Card from './Card/Card';
// =========================

export default function Ambassadors() {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(AmbassadorIndex());
    }, []);

    const ambassadors = useSelector((state) =>
        state.ambassador.entities.allIds
            .map((id) => state.ambassador.entities.byId[id])
            ?.sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))
    );

    return (
        <Layout>
            <Container>
                <HeroLayout>
                    <div styleName="wrapper">
                        {ambassadors.map((person) => (
                            <Card person={person} key={person.name} />
                        ))}
                    </div>
                </HeroLayout>
            </Container>
        </Layout>
    );
}
